import * as React from "react";
const SvgRightWrong = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 10 9"
    {...props}
  >
    <path
      fill="#5E6C84"
      d="m6.2 9-.7-.7L6.8 7 5.5 5.7l.7-.7 1.3 1.3L8.8 5l.7.7L8.2 7l1.3 1.3-.7.7-1.3-1.3zm.987-4.5L5.413 2.725l.7-.7 1.063 1.062L9.3.962l.7.713zM0 7.5v-1h4.5v1zm0-4v-1h4.5v1z"
    />
  </svg>
);
export default SvgRightWrong;
